import dayjs from 'dayjs'
import React, { FC } from 'react'
import { Trans } from '@lingui/macro'
import { Box, Text } from 'front-end/src/components'

import { IBusinessHoursByDays } from 'shared/businessHours'
import { findBusinessDate } from 'shared/businessHoursUtils'

export const BusinessHoursScheduleExample: FC<{
  businessHoursSetup: IBusinessHoursByDays
  businessHoursEnabledInOrg: boolean
  actionHasActiveBusinessHours: boolean
  scheduleDay: number | null
  scheduleTime: string | null
}> = ({
  businessHoursSetup,
  businessHoursEnabledInOrg,
  actionHasActiveBusinessHours,
  scheduleDay,
  scheduleTime
}) => {
  if (
    !businessHoursEnabledInOrg ||
    !actionHasActiveBusinessHours ||
    typeof scheduleDay !== 'number' ||
    scheduleTime === null
  ) {
    return null
  }

  const sendDate = new Date()
  sendDate.setHours(Number(scheduleTime.split(':')[0]))
  sendDate.setMinutes(Number(scheduleTime.split(':')[1]))

  const businessDate = findBusinessDate(
    sendDate,
    scheduleDay,
    businessHoursSetup
  )

  return (
    <Box as="section" w="66%" mb="12px !important">
      <Trans>
        <Text as="i">
          Example: If the users join this campaign right now this action will be
          triggered on&nbsp;
          <strong>{dayjs(businessDate).format('L')}</strong>
        </Text>
      </Trans>
    </Box>
  )
}
